import { defaultTrashFilterDocument } from '@griply/utils';
import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import {
  TaskListSearchProvider,
  useTaskListSearch,
} from 'shared/contexts/task-list-search';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { PageTopBar } from './components/page-top-bar';
import { TrashEmptyState } from './components/trash-empty-state';
import * as Styled from './trash.style';

const noOrder = {};
const hideNewTaskRowOverride = { hideNewTaskRow: true };

const TrashContent: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { searchQuery } = useTaskListSearch();

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />
            <Styled.Content ref={scrollRef}>
              <ProvidedTaskFilterList
                scrollElement={scrollRef}
                filterDocument={defaultTrashFilterDocument}
                defaultFilterDocument={defaultTrashFilterDocument}
                customOrder={noOrder}
                groupSettingOverrides={hideNewTaskRowOverride}
                EmptyState={TrashEmptyState}
                searchQuery={searchQuery}
                includeArchived
                includeTaskWithAction
              />
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>
    </Styled.Container>
  );
};

export const Trash: React.FC = () => (
  <TaskListSearchProvider>
    <TrashContent />
  </TaskListSearchProvider>
);
